<template>
  <b-container>
    <b-overlay :show="show" rounded="sm">
      <b-card class="shadow-sm p-3 rounded mb-3">
        <h4 class="text-center mb-5">Formulario de Registro</h4>
        <b-form @submit.prevent="onSubmit">
          <!-- Información Básica -->
          <!--h5 class="text-primary mb-3">Información Básica</h5-->

          <b-row class="mb-3">
            <b-col cols="12" md="6">
              <b-form-group label="CUIT" label-for="cuit" class="label">
                <b-form-input
                  id="cuit"
                  v-model="form.cuit"
                  required
                  size="sm"
                  type="text"
                  inputmode="numeric"
                  maxlength="11"
                  pattern="\d*"
                  placeholder="Ejemplo: 20304050601"
                  :state="validate('cuit')"
                  @keyup.enter="handleCuitInput"
                />
                <small
                  v-if="touched.cuit && !validate('cuit')"
                  class="text-danger"
                >
                  CUIT inválido. Debe tener 11 dígitos y ser válido.
                </small>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="Razón Social"
                label-for="razon-social"
                class="label"
              >
                <b-form-input
                  id="razon-social"
                  v-model="form.companyName"
                  required
                  size="sm"
                  placeholder="Nombre de la empresa"
                  :state="validate('companyName')"
                  @blur="touched.companyName = true"
                ></b-form-input>
                <small
                  v-if="touched.companyName && !form.companyName"
                  class="text-danger"
                  >Este campo es obligatorio</small
                >
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col cols="12" md="6">
              <b-form-group
                label="Domicilio Fiscal"
                label-for="domicilio-fiscal"
                class="label"
              >
                <b-form-input
                  id="domicilio-fiscal"
                  v-model="form.taxDomicile"
                  required
                  size="sm"
                  placeholder="Dirección fiscal"
                  :state="validate('taxDomicile')"
                  @blur="touched.taxDomicile = true"
                ></b-form-input>
                <small
                  v-if="touched.taxDomicile && !form.taxDomicile"
                  class="text-danger"
                  >Este campo es obligatorio</small
                >
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="Código Postal"
                label-for="codigo-postal"
                class="label"
              >
                <b-form-input
                  id="codigo-postal"
                  v-model="form.postalCode"
                  required
                  size="sm"
                  placeholder="Ejemplo: 1234"
                  :state="validate('postalCode')"
                  @blur="touched.postalCode = true"
                ></b-form-input>
                <small
                  v-if="touched.postalCode && !form.postalCode"
                  class="text-danger"
                  >Este campo es obligatorio</small
                >
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Selectores de province y city -->
          <b-row class="mb-3">
            <b-col cols="12" md="6">
              <b-form-group
                label="Provincia"
                label-for="province"
                class="label"
              >
                <b-form-select
                  id="province"
                  v-model="form.province"
                  :options="provinces"
                  required
                  size="sm"
                  :state="validate('province')"
                  @change="getCities(form.province)"
                ></b-form-select>
                <small
                  v-if="touched.province && !form.province"
                  class="text-danger"
                  >Este campo es obligatorio</small
                >
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Localidad" label-for="city" class="label">
                <b-form-select
                  :disabled="form.province == 0"
                  id="city"
                  v-model="form.city"
                  :options="citiesFromProvince"
                  required
                  size="sm"
                  :state="validate('city')"
                ></b-form-select>
                <small v-if="touched.city && !form.city" class="text-danger"
                  >Este campo es obligatorio</small
                >
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Información Bancaria -->
          <!--h5 class="text-primary mb-3">Información Bancaria</h5-->
          <b-row class="mb-3">
            <b-col>
              <b-form-group label="CBU" label-for="cbu" class="label">
                <b-form-input
                  id="cbu"
                  v-model="form.cbu"
                  required
                  size="sm"
                  type="text"
                  inputmode="numeric"
                  maxlength="22"
                  placeholder="Ejemplo: 0123456789012345678901"
                  :state="validate('cbu')"
                  @blur="touched.cbu = true"
                />
                <small
                  v-if="touched.cbu && !validate('cbu')"
                  class="text-danger"
                >
                  CBU inválido. Debe tener 22 dígitos numéricos válidos.
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Información de Contacto -->
          <!--h5 class="text-primary mb-3">Información de Contacto</h5-->
          <b-row class="mb-3">
            <b-col cols="12" md="6">
              <b-form-group label="Email" label-for="email" class="label">
                <b-form-input
                  id="email"
                  type="email"
                  v-model="form.email"
                  required
                  size="sm"
                  placeholder="correo@ejemplo.com"
                  :state="validate('email')"
                  @blur="touched.email = true"
                ></b-form-input>
                <small v-if="touched.email && !form.email" class="text-danger"
                  >Email inválido</small
                >
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Teléfono" label-for="phone" class="label">
                <b-form-input
                  id="phone"
                  v-model="form.phone"
                  required
                  size="sm"
                  placeholder="Ejemplo: +5491145678901"
                  :state="validate('phone')"
                  @blur="touched.phone = true"
                ></b-form-input>
                <small v-if="touched.phone && !form.phone" class="text-danger"
                  >Este campo es obligatorio</small
                >
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Archivos -->
          <!--h5 class="text-primary mb-3">Carga de Archivos</h5-->
          <!-- Inscripción frente al IVA -->
          <hr />
          <b-col cols="12">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Condición frente a IVA" class="label">
                  <b-form-radio-group
                    v-model="form.inscriptionIva"
                    :options="ivaOptions"
                    name="inscriptionIva"
                    stacked
                  ></b-form-radio-group>
                  <small
                    v-if="touched.inscriptionIva && !form.inscriptionIva"
                    class="text-danger"
                    >Debe seleccionar una opción</small
                  >
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label-for="file-iva" class="label mt-3">
                  <b-form-file
                    id="file-iva"
                    @change="onFileChange('iva', $event)"
                    size="sm"
                    :state="!!files.iva"
                  ></b-form-file>
                  <small v-if="files.iva" class="text-muted"
                    >Archivo cargado: {{ files.iva.name }}</small
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <hr />
          <b-col cols="12">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Inscripción en IIBB" class="label">
                  <b-form-radio-group
                    v-model="form.inscriptionIibb"
                    :options="iibbOptions"
                    name="inscriptionIibb"
                    stacked
                  ></b-form-radio-group>
                  <small
                    v-if="touched.inscriptionIibb && !form.inscriptionIibb"
                    class="text-danger"
                    >Debe seleccionar una opción</small
                  >
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label-for="file-iibb" class="label mt-3">
                  <b-form-file
                    id="file-iibb"
                    @change="onFileChange('iibb', $event)"
                    size="sm"
                    :state="!!files.iibb"
                  ></b-form-file>
                  <small v-if="files.iibb" class="text-muted"
                    >Archivo cargado: {{ files.iibb.name }}</small
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <hr />
          <b-col cols="12">
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Posee exenciones o exclusiones"
                  class="label"
                >
                  <b-form-radio-group
                    v-model="form.exemption"
                    :options="exemptionOptions"
                    name="exemption"
                    stacked
                  ></b-form-radio-group>
                  <small
                    v-if="touched.exemption && !form.exemption"
                    class="text-danger"
                    >Debe seleccionar una opción</small
                  >
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label-for="file-exemption" class="label mt-3">
                  <b-form-file
                    id="file-exemption"
                    multiple
                    @change="onFileChange('exemption', $event)"
                    size="sm"
                  ></b-form-file>
                  <ul
                    v-if="files.exemption.length"
                    class="list-unstyled file-list mt-2"
                  >
                    <div v-for="(file, index) in files.exemption" :key="index">
                      <b-badge
                        @click="removeFile('exemption', index)"
                        href="#"
                        variant="info"
                        >{{ file.name }} - <i class="fas fa-trash-alt"></i
                      ></b-badge>
                    </div>
                  </ul>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <!-- Botón de envío -->
          <div class="text-center mt-4">
            <b-button
              :disabled="isDisableButtonSend"
              type="submit"
              variant="primary"
              class="px-5 rounded-pill"
              >Enviar</b-button
            >
          </div>
        </b-form>
      </b-card>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
          <p id="cancel-label">{{ msgLoading }}</p>
        </div>
      </template>
    </b-overlay>

    <!-- Modal -->
    <b-modal
      id="success-modal"
      title=""
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      centered
    >
      <div class="text-center">
        <h5>Datos guardados exitosamente</h5>
        <p>En breve recibirá un correo con la devolución realizada.</p>
        <b-button variant="primary" @click="redirectToHome">Aceptar</b-button>
      </div>
    </b-modal>
    <!-- Modal de validación -->
    <b-modal
      id="modal-validation-error"
      title="Error de Validación"
      hide-footer
      centered
    >
      <b-container>
        <b-row>
          <b-col>
            <b-alert
              variant="danger"
              show
              fade
              id="alert-validation-error"
              class="text-center"
            >
              <h5>Por favor, verifique los datos ingresados.</h5>
              <ul>
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </b-alert>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-container>
</template>
  
  <script>
import axios from "../../utils/axios";

export default {
  data() {
    return {
      msgLoading: "Cargando...",
      show: false,
      form: {
        cuit: "",
        companyName: "",
        taxDomicile: "",
        postalCode: "",
        cbu: "",
        email: "",
        phone: "",
        province: 0,
        city: 0,
        inscriptionIva: null,
        inscriptionIibb: null,
        exemption: null,
      },
      ivaOptions: [
        { value: "ri", text: "RI (Responsable Inscripto)" },
        { value: "mt", text: "Monotributo" },
        { value: "ex", text: "Exento" },
      ],
      iibbOptions: [
        { value: "lo", text: "Local" },
        { value: "cm", text: "Convenio Multilateral" },
        { value: "nri", text: "No registra inscripción" },
      ],
      exemptionOptions: [
        { value: "si", text: "Si" },
        { value: "no", text: "No" },
      ],
      touched: {
        cuit: false,
        companyName: false,
        taxDomicile: false,
        postalCode: false,
        province: false,
        city: false,
        cbu: false,
        email: false,
        phone: false,
        inscriptionIva: false,
      },
      files: {
        iva: null,
        iibb: null,
        exemption: [],
      },
      provinces: [],
      cities: [],
      citiesFromProvince: [],
      errors: [],
    };
  },
  computed: {
    onCBUInput(e) {
      const clean = e.replace(/\D/g, "").slice(0, 22);
      this.form.cbu = clean;
    },
    formatCUIT(value) {
      if (!/^\d{11}$/.test(value)) return value;
      return `${value.slice(0, 2)}-${value.slice(2, 10)}-${value.slice(10)}`;
    },
    cleanCUIT(value) {
      return value.replace(/\D/g, "");
    },
    isValidEmail() {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(this.form.email);
    },
    isDisableButtonSend() {
      const isDisabled = !(
        this.form.companyName.length > 0 &&
        this.form.taxDomicile.length > 0 &&
        this.form.postalCode.length == 4 &&
        this.form.cbu.length == 22 &&
        this.isValidEmail &&
        this.form.phone.length > 0 &&
        this.form.province &&
        this.form.city &&
        this.form.inscriptionIva &&
        this.form.inscriptionIibb &&
        this.form.exemption &&
        this.isValidCUIT
      );
      return isDisabled;
    },
  },
  mounted() {
    this.getProvincesAndCities();
  },
  methods: {
    handleCuitInput() {
      this.touched.cuit = true;
      this.getArcaRegistrationStatus();
    },
    getArcaRegistrationStatus() {
      if (!this.isValidCUIT(this.form.cuit)) {
        /*this.$bvToast.toast("CUIT inválido. Debe tener 11 dígitos y ser válido.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });*/
        return;
      }
      this.show = true;
      axios
        .get(
          `https://intranet.luquin.com.ar/api/afip/getArcaRegistrationStatus?cuit=${this.form.cuit}`
        )
        .then((response) => {
          this.show = false;
          const datos = response.data.personaReturn.datosGenerales;
          const domicilio = datos.domicilioFiscal;
          let razonSocial;
          if (datos.tipoPersona === "FISICA") {
            razonSocial = `${datos.apellido ?? ""} ${
              datos.nombre ?? ""
            }`.trim();
          } else if (datos.tipoPersona === "JURIDICA") {
            razonSocial = datos.razonSocial ?? "";
          } else {
            razonSocial = "";
          }
          this.form.companyName = razonSocial;
          this.form.taxDomicile = domicilio?.direccion ?? "";
          this.form.postalCode = domicilio?.codPostal ?? "";
          const found = this.provinces.find(
            (prov) =>
              this.normalize(prov.text) ===
              this.normalize(domicilio?.descripcionProvincia)
          );
          if (found) {
            this.form.province = found.value;
            //Buscamos las ciudades de la provincia seleccionada
            this.citiesFromProvince = this.cities.filter(
              (city) => city.province_id == this.form.province
            );

            this.citiesFromProvince.unshift({
              value: 0,
              text: "Seleccione una Ciudad...",
            });
            const foundCity = this.citiesFromProvince.find(
              (city) =>
                this.normalize(city.text) ===
                this.normalize(domicilio?.localidad)
            );
            this.form.city = 0; // Resetear ciudad al seleccionar provincia
            if (foundCity) {
              this.form.city = foundCity.value;
            }
          }
        });
    },
    normalize(str) {
      return str
        .normalize("NFD") // Descompone los acentos
        .replace(/[\u0300-\u036f]/g, "") // Quita los acentos
        .toLowerCase()
        .trim();
    },
    isValidCBU(cbu) {
      if (!/^\d{22}$/.test(cbu)) return false;
      const mod10 = (str) => {
        const digits = str.split("").map(Number);
        const weights = [7, 1, 3, 9, 7, 1, 3];
        const sum = digits
          .slice(0, 7)
          .reduce((acc, d, i) => acc + d * weights[i], 0);
        const checkDigit = (10 - (sum % 10)) % 10;
        return checkDigit === digits[7];
      };
      const mod11 = (str) => {
        const digits = str.split("").map(Number);
        const weights = [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3];
        const sum = digits
          .slice(0, 13)
          .reduce((acc, d, i) => acc + d * weights[i], 0);
        const checkDigit = (10 - (sum % 10)) % 10;
        return checkDigit === digits[13];
      };
      return mod10(cbu.slice(0, 8)) && mod11(cbu.slice(8));
    },
    onFileChange(type, event) {
      if (type === "iva" || type === "iibb") {
        // Reemplaza el archivo previo
        this.files[type] = event.target.files[0] || null;
      } else if (type === "exemption") {
        // Acumula los nuevos archivos al array existente
        const newFiles = Array.from(event.target.files);
        // Verificar que la cantidad total no supere 3
        const totalFiles = this.files.exemption.length + newFiles.length;
        if (totalFiles > 3 || newFiles.length > 3) {
          this.errors = [
            "No se pueden cargar más de 3 archivos de exención.",
          ];
          this.$bvModal.show("modal-validation-error");
          return;
        }
        this.files.exemption = [...this.files.exemption, ...newFiles];
      }
    },
    removeFile(type, index) {
      if (type === "exemption") {
        // Remover archivo del array
        this.files.exemption.splice(index, 1);
      }
    },
    onSubmit() {
      this.show = true;
      this.msgLoading = "Guardando Datos del Proveedor...";
      let formData = new FormData();
      formData.append("cuit", this.form.cuit);
      formData.append("company_name", this.form.companyName);
      formData.append("tax_domicile", this.form.taxDomicile);
      formData.append("postal_code", this.form.postalCode);
      formData.append("cbu", this.form.cbu);
      formData.append("email", this.form.email);
      formData.append("phone", this.form.phone);
      formData.append("province_id", this.form.province);
      formData.append("city_id", this.form.city);
      formData.append("vat_condition", this.form.inscriptionIva);
      formData.append("iibb_registration", this.form.inscriptionIibb);
      formData.append("exemption", this.form.exemption);
      formData.append("files[0]", this.files.iva);
      formData.append("files[1]", this.files.iibb);
      for (var i = 0; i < this.files.exemption.length; i++) {
        let file = this.files.exemption[i];
        formData.append("files[" + (i + 2) + "]", file);
      }
      axios
        .post("/providers/save", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.msjModal = response.data;
          this.show = false;
          this.$bvModal.show("success-modal");
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            // Mostrar el modal de validación
            this.errors = error.response.data.errors;
            this.$bvModal.show("modal-validation-error");
          }
          console.error(error);
          this.show = false;
        });
    },
    getProvincesAndCities() {
      this.msgLoading = "Cargando...";

      this.show = true;
      axios
        .get("/getProvincesAndCities")
        .then((response) => {
          this.provinces = response.data.provinces;
          this.cities = response.data.cities;
          this.provinces.unshift({
            value: 0,
            text: "Seleccione una Provincia...",
          });
          this.show = false;
        })
        .catch((error) => {
          console.error("Error al obtener provincias:", error);
          this.show = false;
        });
    },
    getCities(provinceId) {
      this.citiesFromProvince = this.cities.filter(
        (city) => city.province_id == provinceId
      );
      this.citiesFromProvince.unshift({
        value: 0,
        text: "Seleccione una Ciudad...",
      });
    },
    validate(item) {
      if (!this.touched[item]) return null;
      const validations = {
        companyName: () => this.form.companyName.length > 0,
        taxDomicile: () => this.form.taxDomicile.length > 0,
        postalCode: () => this.form.postalCode.length === 4,
        cbu: () => this.isValidCBU(this.form.cbu),
        email: () => this.isValidEmail,
        phone: () => this.form.phone.length > 0,
        cuit: () => this.isValidCUIT(this.form.cuit),
        province: () => this.form.province > 0,
        city: () => this.form.city > 0,
      };
      return validations[item] ? validations[item]() : null;
    },
    isValidCUIT(cuit) {
      if (!/^\d{11}$/.test(cuit)) return false;
      const prefix = parseInt(cuit.slice(0, 2), 10);
      const validPrefixes = [20, 23, 24, 27, 30, 33, 34];
      if (!validPrefixes.includes(prefix)) return false;
      const digits = cuit.split("").map(Number);
      const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
      const sum = multipliers.reduce((acc, val, i) => acc + val * digits[i], 0);
      const mod11 = 11 - (sum % 11);
      const checkDigit = mod11 === 11 ? 0 : mod11 === 10 ? 9 : mod11;
      return checkDigit === digits[10];
    },
    redirectToHome() {
      this.$router.push({ name: "home" });
    },
  },
};
</script>
  
  <style scoped>
.file-list {
  max-height: 80pt; /* Ajusta esta altura según tus necesidades */
  overflow-y: auto;
  border: 1px solid #ddd; /* Opcional: para visualizar el contenedor */
  padding: 5px; /* Opcional: para añadir espacio interno */
  background-color: #f9f9f9; /* Opcional: para diferenciar el área */
  border-radius: 4px; /* Opcional: bordes redondeados */
}
.b-form-input,
.b-form-file {
  font-size: 0.875rem; /* Size sm */
}

.b-button {
  font-size: 1rem;
  padding: 8px 20px;
  border-radius: 25px;
}

.b-form-file {
  padding-top: 4px;
}
.label {
  font-size: 9pt !important;
  text-align: left;
  margin-bottom: 1pt !important;
}
/* Personalización del scrollbar */
.file-list::-webkit-scrollbar {
  width: 8px; /* Ancho del scroll */
}

.file-list::-webkit-scrollbar-track {
  background: #f0f0f0; /* Fondo de la pista del scroll */
  border-radius: 4px;
}

.file-list::-webkit-scrollbar-thumb {
  background: #cccccc; /* Color de la barra de desplazamiento */
  border-radius: 4px;
  transition: background 0.3s ease; /* Suavidad al interactuar */
}

.file-list::-webkit-scrollbar-thumb:hover {
  background: #999999; /* Color al pasar el mouse */
}

/* Para navegadores que no soportan -webkit- */
.file-list {
  scrollbar-width: thin; /* Scroll más delgado */
  scrollbar-color: #cccccc #f0f0f0; /* Color de la barra y el fondo */
}
/* Estilo minimalista */
.b-modal .modal-header {
  border-bottom: none;
}

.b-modal .modal-content {
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}

.b-modal .modal-body {
  font-size: 16px;
  color: #555;
}
</style>
  